<h1 i18n>Confirm e-mail address</h1>

@if (userDetails$ | async; as userDetails) {
<div class="mb-3">
    <p i18n>
        Please confirm that
        <a href="mailto:{{ userDetails.email }}">{{ userDetails.email }}</a>
        is an e-mail address for user {{ userDetails.username }}.
    </p>

    <button class="btn btn-primary" (click)="confirm()">
        <span i18n>Confirm</span>
        @if (loading$ | async) {
        <div class="spinner-border spinner-border-sm ms-1" role="status">
            <span class="visually-hidden" i18n>Verifying email...</span>
        </div>
        }
    </button>
</div>
} @else {
<section class="no-user-details mt-4">
    <h5 i18n>User details could not be verified.</h5>
    <p i18n>
        Please check the URL, refresh the page and request a new verification
        link if the problem persists.
    </p>
</section>
}
